import TextareaResize from './textareaResize';
import BurgerMenu from './burgerMenu';
import ScrollToBlock from './scrollToBlock';
import Validate from './validate';
import InputmaskClass from './inputmask';
import initCarousel from './carousel';
import changePlaceholderFileInput from './changePlaceholderFileInput';
import './form-go';

let app = {
    init() {
        new TextareaResize();
        new BurgerMenu();
        new ScrollToBlock();
        new Validate();
        new InputmaskClass();
        initCarousel();
        changePlaceholderFileInput();
        func.jsScrollTo();
        func.jsInputmask();
        func.jsValidate();
        func.jsSlider();
        func.jsProgram();
    },
    load() {

    },
    resize() {

    },
    scroll() {

    }
};

let func = {
    jsScrollTo() {
        $(".js-scroll-to").each(function () {
            let $el = $(this);
            let $target = $($el.data('target'));

            $el.not('.initialised').click((e) => {

                $('html, body').stop().animate({
                    scrollTop: ($target.offset().top - 10)
                }, 300);
                e.preventDefault();
            });

            $el.addClass('initialised');
        });
    },
    jsInputmask() {
        $(".js-inputmask").inputmask();
    },
    jsValidate() {
        let errors = {
            emptyText: 'Поле обязательно для заполнения',
            wrongText: 'Некорректный формат',
            largeSize: 'Файл не должен превышать 16мб'
        };

        function validate($el) {
            let errorBlock = $el.next('.landing__form-errors');

            let val = $el.val().trim();
            let checked = $el.prop("checked");
            let isComplete = true;
            let regex = $el.data('regex') || false;

            if (regex) {
                regex = !new RegExp(regex).test(val);
            }

            if ($el.hasClass('js-inputmask')) {
                isComplete = $el.inputmask('isComplete');
            }

            if (val === '') {
                errorBlock.removeClass('hide');
                errorBlock.text(errors.emptyText);
                $el.addClass('landing__form-input--has-errors');
            } else if (!isComplete) {
                errorBlock.text(errors.wrongText);
                errorBlock.removeClass('hide');

                $el.addClass('landing__form-input--has-errors');
            } else if (regex) {
                errorBlock.text(errors.wrongText);
                errorBlock.removeClass('hide');

                $el.addClass('landing__form-input--has-errors');
            } else {
                errorBlock.addClass('hide');
                $el.removeClass('landing__form-input--has-errors');
            }

            if ($el.attr('name') === 'policy') {
                if (checked) {
                    errorBlock = $el.next().next('.landing__form-errors');
                    errorBlock.addClass('hide');

                    $el.removeClass('landing__form-input--has-errors');
                } else {
                    errorBlock = $el.next().next('.landing__form-errors');
                    errorBlock.text(errors.emptyText);
                    errorBlock.removeClass('hide');

                    $el.addClass('landing__form-input--has-errors');
                }
            }
        }

        $(".js-validate").each(function (idx, el) {
            let $el = $(el);

            $el.on('blur', () => {
                validate($el);
            });

            $el.on('focus', () => {
                let errorBlock = $el.next('.landing__form-errors');
                errorBlock.addClass('hide');

                if ($el.attr('type') === 'file') {
                    $el = $el.prev('.file-upload__input');
                }

                $el.removeClass('landing__form-input--has-errors');
            });

        });

        $('[data-validate-files]').change(function(){
            console.log('ss')
            let filesExt = ['pdf', 'doc', 'docx'];
            let parts = $(this).val().split('.');
            let $el = $(this).prev('.file-upload__input');
            let errorBlock = $(this).next('.landing__form-errors');

            let size = 16 * 1024 * 1024;
            let form = document.getElementById('file-upload');
            let file = form.files[0];

            if (filesExt.join().search(parts[parts.length - 1]) === -1) {
                $el.addClass('landing__form-input--has-errors');
                errorBlock.removeClass('hide');
                errorBlock.text(errors.wrongText);
            } else if (file.size > size) {
                $el.addClass('landing__form-input--has-errors');
                errorBlock.removeClass('hide');
                errorBlock.text(errors.largeSize);
            } else {
                $el.removeClass('landing__form-input--has-errors');
                errorBlock.addClass('hide');
                errorBlock.text('');
            }
        });

        function validateFileEmpty() {
            let $el = $('[data-validate-files]');
            let fileBlock = $el.prev('.file-upload__input');
            let errorBlock = $el.next('.landing__form-errors');

            let form = document.getElementById('file-upload');
            let file = form.files[0];

            if (typeof file === 'undefined') {
                fileBlock.addClass('landing__form-input--has-errors');

                errorBlock.removeClass('hide');
                errorBlock.text(errors.emptyText);
            }
        }

        $(".js-validate-form").on('submit', (e) => {
            let $el = $(e.currentTarget);
            $el.find('.js-validate').each(function (idx, el) {
                let $el = $(el);
                validate($el);
            });
            if (window.location.pathname != '/manager/' && window.location.pathname != '/') {
                validateFileEmpty();
            }

            if ($el.find('.landing__form-input--has-errors').length > 0) {
                e.preventDefault();
                e.stopImmediatePropagation();
            }
        });
    },
    jsSlider() {
        $(".owl-carousel").owlCarousel({
            items: 1,
            dots: false,
            nav: true,
            loop: true
        });
    },
    jsProgram() {
        $(".js-program").each(function (idx, el) {
            let $el = $(el);

            let $elToggler = $el.find('.js-program-toggler');
            let $elContent = $el.find('.js-program-content');

            $elToggler.on('click', () => {
                $elContent.slideToggle();
                $el.toggleClass('program__item--active')
            })
        });
    },
};

$(function () {
    app.init();

    $(window).on('load', function () {
        app.load();
    });

    $(window).on('resize', function () {
        app.resize();
    });

    $(window).on('scroll', function () {
        app.scroll();
    });

});
